export const CONTEXT_TYPES = {
  RESULTS: "RESULTS", // rename to default
  RESERVATION: "RESERVATION",
  RESERVATION_ALTERNATIVES: "RESERVATION_ALTERNATIVES",
  CHANGE_FLIGHTS: "CHANGE_FLIGHTS",
  RESERVATION_SUMMARY: "RESERVATION_SUMMARY",
  MMB: "MMB",
  MMB_OVERVIEW: "MMB_OVERVIEW",
  MMB_HISTORY: "MMB_HISTORY",
} as const

export const PART_TYPES = {
  FLIGHT: "flight",
  TRAIN: "train",
  BUS: "bus",
} as const

export type PartType = typeof PART_TYPES[keyof typeof PART_TYPES]

export const HIDING_REASON_TYPES = {
  THC: "thc",
  TAT: "tat",
} as const
